import { memo } from "react";
import { IconPlayerPlayFilled, IconPlayerPauseFilled } from "@tabler/icons-react";

import { Tooltip } from "@fragments";

/**
 * AutoplaySwitch — miniature recessed-well switch (the house toggle metaphor)
 * controlling "reprodução automática", YouTube-style.
 */
function AutoplaySwitch({ enabled, onChange }) {
    return (
        <Tooltip
            content={enabled ? "Reprodução automática ativada" : "Reprodução automática desativada"}
            placement="top"
        >
            <button
                type="button"
                role="switch"
                aria-checked={enabled}
                aria-label="Reprodução automática"
                className={`player-control-button player-autoplay ${enabled ? "on" : ""}`}
                onClick={(event) => {
                    event.stopPropagation();
                    onChange(!enabled);
                }}
            >
                <span className="player-autoplay__label">Autoplay</span>
                <span className="player-autoplay__track">
                    <span className="player-autoplay__thumb">
                        {enabled ? <IconPlayerPlayFilled /> : <IconPlayerPauseFilled />}
                    </span>
                </span>
            </button>
        </Tooltip>
    );
}

export default memo(AutoplaySwitch);
